import React, {Component} from 'react';
import {connect} from '~/redux/connect';
import cn from 'classnames';
import {modelActionsCreator} from "~/actions/model_actions";
import {getFilters, getGroups, getGroupStates, getFilterOrder, getModelTooltip, getAllResultStateInfos, getSearchFilterByModelId, getParentSubview} from "~/stateGetter";
import {presentGroups, deriveNewListOrder, presentAppliedFilterValues, presentFilters} from "~/statePresenter";
import commoncss from '~/themes/common.css';

import { Button, Popover, Pressable, ScrollView, Tooltip } from "~/native-ui"
import toOrderedArray from "~/lib/toOrderedArray";

import debounce from 'lodash/debounce';
import get from "lodash/get"
import keys from "lodash/keys";
import omit from "lodash/omit";
import keyBy from "lodash/keyBy";
import isEqual from "lodash/isEqual";
import OtherFilterFields from './OtherFilterFields';
import { compareKeys } from "mythil/object";
import { filterPopoverProps } from './filterPopoverProps';
import { settingsActionCreator } from '../../actions/settingsActions';


const areStatePropsEqual = (prev, curr) => {
    return compareKeys(prev, curr, (prev, curr, key) => {
        switch (key) {
            case "appliedFilters": return isEqual(prev, curr);
            default: return prev === curr;
        }
    })
}

const mapStateToFilterMenuProps = (state, { modelId }) => {
    let modelStateInfo = getAllResultStateInfos(state, modelId),
        modelSearchFilter = getSearchFilterByModelId(state, modelId),
        filters = keyBy(presentFilters({
            filters: modelStateInfo.filters,
            parentSubview: modelStateInfo.parentSubview,
        }), "name"),
        appliedFilters = keys(presentAppliedFilterValues({...modelStateInfo, filters, takeAllCreatedFilters: true, modelSearchFilter }))
            .reduce((appliedFilters, filterName) => {
                if (!filters[filterName]?.title) {
                    return appliedFilters
                }
                
                return appliedFilters.concat(filters[filterName]?.title);
            }, [])

    return {
        appliedFilters,
    }
}

let FilterMenuTrigger = React.forwardRef((props, ref) => {
    const { appliedFilters, trans, ...rest } = omit(props, "fallbackLanguage", "language", "modelId", "dispatch");
    let label = "",
        count = appliedFilters.length,
        ghost = false,
        buttonProps = {
            ...rest,
        }

    switch (count) {
        case 0:
            label = trans('filter');
            break;
        case 1:
            label = trans('filters.filtered_by', { filters: appliedFilters.filter(Boolean).join(", ") });
            ghost = true
            break;
        default: 
            label = trans("filters.filtered_by_more_1", {
                ...appliedFilters,
                count: count - 1
            });
            ghost = true
        }


        buttonProps = {
            ...buttonProps,
            iconSize: "sm",
            ghost,
        }


    return (
        <Tooltip tooltip={label} tooltipClassName="filterMenuTooltip">
            <Pressable ref={ref} { ...rest } position="relative">
                    <Button
                        primary
                        key="button"
                        badge={count}
                        // label={label}
                        icon="filter-alt"
                        {...buttonProps}
                    />
            </Pressable>
        </Tooltip>
    )
})

FilterMenuTrigger = connect(mapStateToFilterMenuProps, null, null, { areStatePropsEqual, forwardRef : true })(FilterMenuTrigger);

export { FilterMenuTrigger }

export class FilterMenu extends Component {
	static propTypes = {
	
	};

    filterOption() {
    }

    resetFilters = () => {
        this.props.onResetFilters()
    }


    getCaption(filter, onClick) {
        let { open, title } = filter;

        return (
            title
            // <Checkbox checked={ open } onChange={ onClick } >
            //     {title}
            // </Checkbox>
        )
    }

    filterItems = () => {
        let { filters } = this.props;


        let items = filters
            .map((filter) => {
                const { open, name, group } = filter;
                let className = cn({ [commoncss.uncheckedMenuItem]: !open});
                const onClick = debounce((e) => { this.props.onChangeFilterOpen(group, name, !open) }, { leading: true })

                return <MenuItem
                    checkable
                    key={name}
                    value={ name }
                    className={className}
                    caption={this.getCaption(filter, onClick)}
                    onClick={onClick}
                />
            });

        return items;
    };


    getAppliedFilters() {

    }

    renderTrigger = (props) => {
        return (
            <FilterMenuTrigger modelId={this.props.modelId} { ...this.props.triggerProps } {...props }/>
        )
    }

	render() {
		return (
            <Popover
                trapFocus
                shouldFlip
                shadow="2"
                placement={this.props.placement}
                isKeyboardDismissable
                trigger={ this.renderTrigger }
                initialFocusRef={null}
            >
                <Popover.Content { ...filterPopoverProps }>
                    <Popover.Arrow height={10} width={10} />
                    <Popover.Body>
                        <ScrollView maxHeight="50vh">
                            <OtherFilterFields mt={4} modelId={this.props.modelId} />
                        </ScrollView>
                    </Popover.Body>
                </Popover.Content>
            </Popover>
		);
	}
}

const RXFilterMenu = connect(
    (state, { modelId }) => {
        return {
            modelSearchFilter: getSearchFilterByModelId(state, modelId),
            filters: getFilters(state, modelId),
            groups: getGroups(state, modelId),
            groupStates: getGroupStates(state, modelId),
            settingsGroupStates: getGroupStates(state, modelId),
            filterOrder: getFilterOrder(state, modelId),
            parentSubview: get(getParentSubview(state, modelId), "parentSubview"),
        };
    },
    (dispatch, { modelId }) => {
        let modelActions  = modelActionsCreator(modelId),
            settingActions = settingsActionCreator(modelId);

        return {
            changeGroupOpen: (name, open) => dispatch(modelActions.changeGroupOpen(name, open)),
            changeFilterOpen: (name, filterName, open) => dispatch(modelActions.changeFilterOpen(name, filterName, open)),
            changeFilterOrder: (filterOrder) => dispatch(modelActions.changeFilterOrder(filterOrder)),
            resetFilters: () => dispatch(modelActions.resetFilters()),
        }
    },
    ({ filters, groups, groupStates, modelSearchFilter, parentSubview, filterOrder = {} }, { changeGroupOpen, changeFilterOpen, changeFilterOrder, resetFilters }, ownProps) => {
        let modelFilters = toOrderedArray(presentGroups({
                parentSubview,
                filters,
                groups,
                groupStates
            }))
            .map((group) => ({ open: group.open, title: group.title, name: group.name, filters: group.filters }))
            .reduce((allFilters, group) => allFilters.concat(group.filters), [])
            .map((filter, index) => ({
                ...filter,
                builder_order: get(filterOrder, filter.name) || filter.builder_order + 1 || filter.order + 1 || index + 1,
                displayOrder: get(filterOrder, filter.name) || filter.builder_order + 1 || filter.order + 1 || index + 1
            })).filter((filter) => filter.name !== modelSearchFilter);


        return {
            ...ownProps,
            filterOrder,
            filters: toOrderedArray(modelFilters),
            onResetFilters: resetFilters,
            onChangeGroupOpen: changeGroupOpen,
            onChangeFilterOpen: changeFilterOpen,
            changeFilterOrder,
            deriveNewListOrder
        }
    },
)(FilterMenu);

export default RXFilterMenu;